import React, { useEffect } from "react";
import UserData from "./userdata";
import Information from "./information";
import Details from "./detail";
import { useParams } from "react-router-dom";
import { apiGet } from "../../api/api_methods";
import { useState } from "react";
import { Observer } from "mobx-react";
import { useStores } from "../../store";
import PdfViewer from "../reusble_components/pdfViewer";
import Loader from "../reusble_components/loader";
export default function Profile() {
  const { id } = useParams();
  const [data, setData] = useState({});
  const [img, setImg] = useState(
    "data:image/png;base64,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"
  );
  const [exp, setexp] = useState([]);
  const [courses, setcourses] = useState([]);
  const [interview, setinterview] = useState([]);
  const [resume, setResume] = useState("");
  const [loading, setLoading] = useState(true);
  const { CommonStore } = useStores();
  useEffect(() => {
    console.log(id);
    getDetails();
  }, [id]);
  const getDetails = async () => {
    const response = await apiGet(`/recruiter/get-candidate-details/${id}`);
    if (response.status === 200) {
      setLoading(false);
      console.log(response.body);
      setSkills(response.body.data.userData?.skills);
      try {
        if (response.body.data.userData?.pic.length > 0) {
          setImg(response.body.data.userData?.pic);
        }
      } catch (err) {
        console.log(err);
      }

      setexp(response.body.data.userData?.previousCompanies);
      setcourses(response.body.data?.coursesData);
      setinterview(response.body.data?.interviewData);

      const githubURI = response.body.data?.userData?.gitHub;
      let githubUsername = githubURI; // Default to the URI if it doesn't match the pattern

      // Check if githubURI contains "https://github.com/"
      const githubPrefix = "https://github.com/";
      if (githubURI?.startsWith(githubPrefix)) {
        // Extract the username part after "https://github.com/"
        githubUsername = githubURI.slice(githubPrefix.length);
      }
      setResume(response.body.data.userData.resume);

      const data = {
        tech: response?.body?.data?.userData?.technicalSkills,
        communication: response.body.data?.userData?.communicationSkills,
        overallRating: response.body.data?.userData?.overallRating,
        city: response.body.data?.userData?.city,
        mobile: response.body.data?.userData?.mobile,
        nameOfInstitute: response.body.data?.userData?.college,
        name: response.body.data?.userData?.name,
        designation: response.body.data.userData?.designation,
        mailID: response.body.data.userData?.mail,
        linkedinURI: response.body.data.userData?.linkedIn,
        year: response.body.data?.userData?.year,
        gender: response.body.data?.userData?.gender,
        location: "-",
        age: "-",
        githubURI: githubUsername, // Use the extracted username
        nameOfCompany: response.body.data?.userData?.college,
        yearsOfExperience: "-",
        lookingFor: response.body.data?.userData?.lookingFor,
        bio: response.body.data?.userData?.bio,
      };
      setData(data);
    } else {
      alert("Something went wrong! Please try again.");
    }
  };

  const [myskills, setSkills] = useState([]);

  return (
    <Observer>
      {() => (
        <>
          {CommonStore.resume && (
            <PdfViewer
              pdfUrl={resume}
              onClose={() => CommonStore.setResume(false)}
            />
          )}
          <Loader loader={loading} />
          <div>
            <div className="md:flex">
              <div className="w-full md:h-[750px]  md:min-w-[17rem] md:max-w-[28%] md:p-5">
                <UserData
                  img={img}
                  name={data.name}
                  role={data.designation}
                  skills={myskills}
                  userId={id}
                  about={data.bio}
                ></UserData>
              </div>

              <div className="w-full h-full md:min-h-[600px] md:min-w-[40rem] md:max-w-[75%] md:p-5">
                <Information
                  nameOfInstitute={data.nameOfInstitute}
                  mailID={data.mailID}
                  linkedinURI={data.linkedinURI}
                  gender={data.gender}
                  year={data.year}
                  location={data.city}
                  age={data.age}
                  githubURI={data.githubURI}
                  nameOfCompany={data.nameOfCompany}
                  yearsOfExperience={data.yearsOfExperience}
                  gitUserName={data.githubURI}
                  tech={data.tech}
                  communication={data.communication}
                  mobile={data.mobile}
                  overallRating={data.overallRating}
                  lookingFor={data.lookingFor}
                  id={id}
                />
              </div>
            </div>
            <div className="md:p-5">
              <Details
                experience={exp}
                course={courses}
                interview={interview}
                data={data}
              ></Details>
            </div>
          </div>
        </>
      )}
    </Observer>
  );
}
